import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { createRiderValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
const DriverForm = (props: any) => {
  const { setOpenAddDriverPopup } = props;
  const {
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(createRiderValidationForm),
  });
  const { mutateAsync: addDriver, isPostLoading: isDriverLoading } =
    usePostHook({
      queryKey: ["riders"],
      navigateURL: "",
    });

  const handleAddDriver = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER_CREATE}`;
    let formData = {
      ...values,
      mobile_number: `+977${values?.mobile_number}`,
    };
    try {
      const res = await addDriver({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddDriverPopup((prev) => !prev);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data: any) => handleAddDriver(data, setError))}
    >
      <div className={tw`grid  md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Username"}
          register={register("username")}
          errors={errors?.username}
        />
        <TextField
          label={"Full Name"}
          register={register("full_name")}
          errors={errors?.full_name}
        />
        <TextField
          label={"Email"}
          register={register("email")}
          errors={errors?.email}
        />
        <TextField
          label={"Mobile Number"}
          register={register("mobile_number")}
          errors={errors?.mobile_number}
        />
        <TextField
          label={"License Number"}
          register={register("license_number")}
          errors={errors?.license_number}
        />
        <TextField
          label={"Ctitizenship Number"}
          register={register("citizenship_number")}
          errors={errors?.citizenship_number}
        />
        <ComboboxInput
          url={APIS.BRANCH}
          queryKey={"branch"}
          register={register("branch")}
          errors={errors?.branch}
          name={"branch"}
          label={"Branch"}
          props={{
            is_active: true,
          }}
          setValue={setValue}
          placeholder={"Select Branch"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
      <div className={tw`flex w-full  justify-end`}>
        <div className={tw`w-32`}>
          <Button label={"Create"} isLoading={isDriverLoading} />
        </div>
      </div>
    </form>
  );
};

export default DriverForm;
